import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

export const BoardContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "backgroundColor"
})<{ backgroundColor: string }>(({ backgroundColor }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 64px)',
  backgroundColor: backgroundColor || '#0D2249',
  overflow: 'hidden', // Impede que o container externo tenha scroll
  padding: '0', // Removido padding para eliminar espaçamento indesejado
  margin: '0',
}));

export const ColumnsContainer = styled(Box)({
  display: 'flex',
  overflowX: 'auto', // Permite scrollagem horizontal
  overflowY: 'auto', // Permite scrollagem vertical para ver todas as colunas
  gap: '16px', // Aumentado espaçamento entre colunas
  padding: '16px 16px 24px 0', // Removido padding esquerdo, aumentado inferior
  margin: '0 0 0 16px', // Margem esquerda para alinhar com o início da primeira coluna
  flexGrow: 1, // Ocupa o espaço disponível
  alignItems: 'flex-start', // Alinha as colunas ao topo
  height: 'calc(100% - 24px)', // Ajustado para dar mais espaço para o scrollbar inferior
  maxWidth: 'calc(100% - 16px)', // Ajustado para considerar a margem esquerda
  '&::-webkit-scrollbar': {
    width: '10px', // Scrollbar vertical
    height: '10px', // Scrollbar horizontal
  },
  '&::-webkit-scrollbar-track': {
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    margin: '0 16px 8px 0', // Ajustada margem para criar espaçamento
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(33, 150, 243, 0.4)', // Cor mais destacada para o scrollbar
    borderRadius: '8px',
    border: '2px solid transparent',
    backgroundClip: 'padding-box',
    '&:hover': {
      background: 'rgba(33, 150, 243, 0.6)',
    }
  },
  // Espaçamento entre scrollbars horizontal e vertical
  '&::-webkit-scrollbar-corner': {
    background: 'transparent',
  }
});

// Component para conter os cards sem scroll vertical
export const ColumnCards = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flexGrow: 1,
});

export const Column = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '300px', // Aumentado de 272px para 300px
  maxWidth: '300px', // Aumentado de 272px para 300px
  backgroundColor: 'rgba(0, 0, 0, 0.16)',
  borderRadius: '8px',
  padding: '12px',
  marginRight: '0', // Removido margin-right, pois o gap do container já cuida do espaçamento
  // Remover limite de altura para permitir que a coluna se estenda
  height: 'auto',
  transition: 'box-shadow 0.2s ease, opacity 0.2s ease',
  '&:hover': {
    boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
  },
  '&.column-drag-over': {
    boxShadow: 'inset 0 -3px 0 rgba(33, 150, 243, 0.8)',
  },
}));

export const ColumnHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 8px 8px 16px',
  marginBottom: '8px',
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
});

export const ColumnTitle = styled(Typography)({
  fontWeight: 'bold',
  color: 'white',
  flexGrow: 1,
});

export const Card = styled(Box)({
  backgroundColor: 'black',
  borderRadius: '4px',
  padding: '8px',
  marginBottom: '8px',
  boxShadow: '0 1px 0 rgba(0,0,0,0.2)',
  cursor: 'pointer',
  transition: 'transform 0.15s, border 0.15s',
  '&:hover': {
    backgroundColor: '#f8f9fa',
  },
  '&.drag-over-top': {
    borderTop: '2px solid rgba(33, 150, 243, 0.8)'
  },
  '&.drag-over-bottom': {
    borderBottom: '2px solid rgba(33, 150, 243, 0.8)'
  }
});

export const AddButton = styled(Button)({
  color: 'white',
  justifyContent: 'flex-start',
  textTransform: 'none',
  padding: '4px 8px',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
});

export const AddColumnButton = styled(Button)({
  backgroundColor: 'rgba(255, 255, 255, 0.1)',
  color: 'white',
  justifyContent: 'flex-start',
  textTransform: 'none',
  padding: '12px',
  minWidth: '300px', // Aumentado de 272px para 300px
  maxWidth: '300px', // Aumentado de 272px para 300px
  width: '300px', // Aumentado de 272px para 300px
  height: 'fit-content',
  borderRadius: '8px',
  flexShrink: 0,
  margin: '0',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
  },
});